import { render, staticRenderFns } from "./TimeAgo.vue?vue&type=template&id=17f5e0b2"
import script from "./TimeAgo.vue?vue&type=script&lang=ts"
export * from "./TimeAgo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports